import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Paper from '@/components/Paper';

import { CODE_BACKGROUND } from './index.constants';

function FixedPopup({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        containerWidth: 100,
        containerHeight: 100,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr 1fr' }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="containerWidth"
          id="containerWidth"
          label="Container Width"
          min={30}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoSliderControl
          key="containerHeight"
          id="containerHeight"
          label="Container Height"
          min={30}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ containerWidth, containerHeight }) => {
        const containerHeightPx = normalize(
          containerHeight,
          30,
          100,
          175,
          334
        );
        return (
          <>
            <Row>
              <Column>{codeOutput}</Column>
              <DemoColumn>
                <Container
                  style={{
                    width: containerWidth + '%',
                    height: containerHeightPx / 16 + 'rem',
                  }}
                >
                  <Background>
                    <Heading>
                      {[2, 6.5, 1, 8, 3].map((width, index) => (
                        <HeadingBlock
                          key={index}
                          style={{ width: `${width}rem` }}
                        />
                      ))}
                    </Heading>
                    <Paragraph>
                      {[
                        2, 1, 2.25, 1, 1.5, 4.75, 1.5, 7, 4, 4.2,
                        1.25, 5, 0.5, 2.1, 4, 0.785, 2.5, 1.5, 0.5,
                        3.5, 1,
                      ].map((width, index) => (
                        <Block
                          key={index}
                          style={{ width: `${width}rem` }}
                        />
                      ))}
                    </Paragraph>
                    <Paragraph>
                      {[
                        0.785, 4.2, 1.25, 4, 1.5, 1.5, 1, 2.25, 0.5,
                        2.1, 2.5, 3.5, 1,
                      ].map((width, index) => (
                        <Block
                          key={index}
                          style={{ width: `${width}rem` }}
                        />
                      ))}
                    </Paragraph>
                    <Paragraph>
                      {[
                        6, 2.25, 4, 1.3, 4.2, 8, 0.5, 1.25, 2.5, 5, 1,
                        4.4, 0.5, 8, 2.1,
                      ].map((width, index) => (
                        <Block
                          key={index}
                          style={{ width: `${width}rem` }}
                        />
                      ))}
                    </Paragraph>
                  </Background>
                  <Modal>
                    <FakeModalHeading>
                      We value your privacy data.
                    </FakeModalHeading>
                    <p>
                      We use cookies to enhance your browser
                      experience by selling this data to advertisers.
                      This is extremely valuable.
                    </p>
                    <FakeFooter>
                      <FakeButton>Sounds good</FakeButton>
                    </FakeFooter>
                  </Modal>
                </Container>
              </DemoColumn>
            </Row>
          </>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
  }
`;
const Column = styled.div`
  position: relative;
  flex: 1;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  min-height: 230px;

  @media (max-width: 34rem) {
    min-height: revert;
  }
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
`;

const Container = styled(Paper)`
  position: relative;
  background: hsl(0deg 0% 90%);
  color-scheme: light;
`;

const Background = styled.div`
  overflow: hidden;
  overflow: clip;
  padding: 16px;

  max-height: 100%;
`;

const Heading = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 1.5em;
`;
const Paragraph = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 1em;
`;

const Block = styled.span`
  background: hsl(0deg 0% 80%);
  border-radius: 2px;
  height: 0.75rem;
`;
const HeadingBlock = styled(Block)`
  height: 1rem;
  background: hsl(0deg 0% 70%);
`;

const Modal = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  width: 175px;
  max-width: calc(100% - 4px * 2);
  margin: auto;
  padding: 8px;
  background: hsl(250deg 80% 40%);
  box-shadow:
    0px 1px 2px hsl(0deg 0% 0% / 0.2),
    0px 2px 4px hsl(0deg 0% 0% / 0.2),
    0px 4px 8px hsl(0deg 0% 0% / 0.2);
  border-radius: 4px;
  color: white;

  p {
    font-size: 0.5rem;
    line-height: 1.2;
  }
`;

const FakeModalHeading = styled.p`
  font-size: 0.8rem;
  margin-bottom: 0.625em;
  font-weight: var(--font-weight-bold);
`;

const FakeFooter = styled.div`
  border-top: 1px solid hsl(250deg 70% 70% / 0.5);
  margin: -8px;
  margin-top: 8px;
  padding: 4px 8px;
`;

const FakeButton = styled.div`
  width: fit-content;
  margin-left: auto;
  padding: 0px 8px;
  background: hsl(250deg 90% 20%);
  font-size: 0.5rem;
  font-weight: var(--font-weight-bold);
  cursor: default;
`;

export default FixedPopup;
